"use strict";var w10NOOP = require("warp10/constants").NOOP;
exports.aJ_ = w10NOOP;
exports.V_ = function () {
  return w10NOOP;
};